import api from "../../utils/api";
import AcConstant from "../../mixins/beaver/const/BeaverAcConstant";

const state = {
  _national: null, // { sigungus: [...], updatedAt }
  _sigunguDetail: null, // { summary, eups, queue, throughput24h, updatedAt }
  // 동명 시군구(서울 중구 ↔ 부산 중구) 구분 위해 (sido, sigungu) 페어로 보관
  _selectedSido: null,
  _selectedSigungu: null,
  _augmentResult: null, // { ok, startedAt, logPath, pid }
  _loading: false,
  _augmenting: false,
};

const mutations = {
  setNational(state, payload) {
    state._national = payload || null;
  },
  setSigunguDetail(state, payload) {
    state._sigunguDetail = payload || null;
  },
  setSelected(state, { sido, sigungu } = {}) {
    state._selectedSido = sido || null;
    state._selectedSigungu = sigungu || null;
  },
  setAugmentResult(state, result) {
    state._augmentResult = result || null;
  },
  setLoading(state, loading) {
    state._loading = !!loading;
  },
  setAugmenting(state, augmenting) {
    state._augmenting = !!augmenting;
  },
  setReset(state) {
    state._sigunguDetail = null;
    state._selectedSido = null;
    state._selectedSigungu = null;
    state._augmentResult = null;
  },
};

const actions = {
  async acFetchNational({ commit }) {
    try {
      commit("setLoading", true);
      const res = await api.get(AcConstant.NATIONAL);
      if (res.data?.code === 0) {
        commit("setNational", res.data.data);
        return res.data.data;
      }
      return null;
    } catch (err) {
      console.log("acFetchNational err", err);
      return null;
    } finally {
      commit("setLoading", false);
    }
  },

  async acFetchSigunguDetail({ commit }, { sido, sigungu }) {
    try {
      commit("setLoading", true);
      // 클릭 시점에 이전 상세 즉시 비우기 — 로딩 인디케이터 보장
      commit("setSigunguDetail", null);
      commit("setSelected", { sido, sigungu });
      const res = await api.get(AcConstant.SIGUNGU(sigungu), {
        params: { sido },
      });
      if (res.data?.code === 0) {
        commit("setSigunguDetail", res.data.data);
        return res.data.data;
      }
      return null;
    } catch (err) {
      console.log("acFetchSigunguDetail err", err);
      return null;
    } finally {
      commit("setLoading", false);
    }
  },

  async acAugmentSigungu({ commit }, sigungu) {
    try {
      commit("setAugmenting", true);
      const res = await api.post(AcConstant.AUGMENT(sigungu), {});
      if (res.data?.code === 0) {
        commit("setAugmentResult", res.data.data);
        return res.data.data;
      }
      return null;
    } catch (err) {
      console.log("acAugmentSigungu err", err);
      return null;
    } finally {
      commit("setAugmenting", false);
    }
  },
};

const getters = {
  getNational: state => state._national,
  getSigunguDetail: state => state._sigunguDetail,
  getSelectedSido: state => state._selectedSido,
  getSelectedSigungu: state => state._selectedSigungu,
  getAugmentResult: state => state._augmentResult,
  getLoading: state => state._loading,
  getAugmenting: state => state._augmenting,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
